
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { AlertTriangle } from 'lucide-react';

export function ComplianceNoticeCard() {
  return (
    <Card className="bg-muted/30">
      <CardHeader className="pb-2">
        <CardTitle className="text-base flex items-center gap-2">
          <AlertTriangle className="h-4 w-4 text-amber-600" />
          Compliance Notice
        </CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-sm text-muted-foreground">
          Retention requirements vary by state. Always ensure your retention policies comply with the latest 
          regulatory requirements for each state where you operate. Failure to maintain proper records can 
          result in regulatory penalties.
        </p>
      </CardContent>
    </Card>
  );
}
